export const POSTS_LIMIT = 15

export const feedTypes = {
  HASHTAG: "feedTypeHashtag",
  ACTIVITY_FEED: "feedTypeActivityFeed",
  GROUP: "feedTypeGroup",
  PROFILE: "feedTypeProfile"
}

// The type is string because it is used as a route parameter
export const groupFeedSortTypes = {
  HOTTEST: "hottest",
  LATEST: "latest"
}
